module.exports = __webpack_public_path__ + "img/607b660.jpg";